import { PButtonPure, PText, PFlex, PFlexItem, PIcon } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'

import ApplicationInformation from '../../utils/Applications'
import Actions from './Actions/Actions'
import SubApp from './SubApp/SubApp'

import { TEXTS } from '../../config/texts'
import { PortalContext } from '../../utils/PortalContext'

import PAGRating from '../../Types'
import styles from './collapsible.module.css'

type Props = {
  app: PAGRating.App
}

const Collapsible = ({ app }: Props) => {
  const [openCollapse, setOpenCollapse] = React.useState(false)

  const { openDrawer, drawerData, setDrawerData, setOpenDrawer, setDrawerContent } = React.useContext(PortalContext)

  const appInfo = ApplicationInformation({ app: app })
  app = {
    ...app,
    appInformation: appInfo
  }

  const openCollapsible = () => {
    if (app.subApp) {
      setOpenCollapse(!openCollapse)
    }
  }

  const openCollapsibleOnce = () => {
    if (app.subApp) {
      setOpenCollapse(true)
    }
  }

  const openDetailsInDrawer = (event: React.MouseEvent) => {
    event.stopPropagation()
    setDrawerData(app)
    setOpenDrawer(true)
    setDrawerContent('DetailsApp')
  }

  const showDetails = (event: React.MouseEvent) => {
    openDetailsInDrawer(event)
    openCollapsibleOnce()
  }

  const SubAppList = app.subApp?.map((subApp: PAGRating.SubApp) => {
    return <SubApp subApp={subApp} key={subApp.subAppId} app={app} />
  })

  return (
    <div className={clsx(styles.dropdown, { [styles.open]: openCollapse })}>
      <PFlex
        className={clsx(
          styles.mainApp,
          {
            [styles.hoverable]: app.subApp
          },
          {
            [styles.active]: openDrawer && drawerData.appInformation?.configId === app.configId
          }
        )}
        onClick={openCollapsible}
        alignContent='center'
      >
        <PFlexItem>
          {app.subApp && app.subApp?.length !== 0 && (
            <PButtonPure hideLabel icon='arrow-head-down' className={styles.dropIcon}>
              {TEXTS.COLLAPSIBLE_OPEN}
            </PButtonPure>
          )}
        </PFlexItem>
        <PFlexItem flex='auto' onClick={showDetails} className={styles.hoverable}>
          <PText weight='bold' className={styles.appTitle}>
            {app.appDescription}
            {(app as any).apiKey && (
              <PIcon name='lock' size='small' color='notification-success' aria-label='API Key geschützt' style={{ marginLeft: '4px', verticalAlign: 'middle' }} />
            )}
          </PText>
          <PText color='neutral-contrast-medium' className={styles.appTitle}>
            {app.icto}
          </PText>
          {app.test && (
            <PText color='neutral-contrast-medium' size='x-small' className={styles.appTitle}>
              {TEXTS.COLLAPSIBLE_TEST_BADGE}
            </PText>
          )}
        </PFlexItem>

        <Actions className={styles.actions} appData={app} />
      </PFlex>
      <div className={styles.dropContent}>{app.subApp && SubAppList}</div>
    </div>
  )
}

export default Collapsible
